// bootstrap-spin - v1.0
// https://shaack.com/projekte/bootstrap-input-spinner/
!function(N){"use strict";function n(t,r){var o=t.locale||"en-US";this.parse=function(t){var e=new Intl.NumberFormat(o),n=e.format(11111).replace(/1/g,"")||".",e=e.format(1.1).replace(/1/g,"");return parseFloat(t.replace(new RegExp(" ","g"),"").replace(new RegExp("\\"+n,"g"),"").replace(new RegExp("\\"+e),"."))},this.render=function(t){var e=parseInt(r.getAttribute("data-decimals"))||0,n=!("false"===r.getAttribute("data-digit-grouping"));return new Intl.NumberFormat(o,{minimumFractionDigits:e,maximumFractionDigits:e,useGrouping:n}).format(t)}}var k=!1,r=N.fn.val;function F(t,e){t.addEventListener("mousedown",function(t){0===t.button&&(t.preventDefault(),e(t))}),t.addEventListener("touchstart",function(t){t.cancelable&&t.preventDefault(),e(t)}),t.addEventListener("keydown",function(t){32!==t.keyCode&&13!==t.keyCode||k||(k=!0,e(t))})}N.fn.val=function(t){var e;return 1<=arguments.length&&this[0]&&this[0]["bootstrap-input-spinner"]&&this[0].setValue&&(e=this[0],setTimeout(function(){e.setValue(t)})),r.apply(this,arguments)},N.fn.inputSpinner=function(t){if("destroy"===t)return this.each(function(){this.destroyInputSpinner()}),this;var e,C={decrementButton:"<strong>&minus;</strong>",incrementButton:"<strong>&plus;</strong>",groupClass:"",buttonsClass:"p2-outline",buttonsWidth:"2.5rem",textAlign:"center",autoDelay:500,autoInterval:50,buttonsOnly:!1,keyboardStepping:!0,locale:navigator.language,editor:n,template:'<div class="input-group ${groupClass}"><div class="input-group-prepend"><button style="min-width: ${buttonsWidth}" class="btn btn-decrement ${buttonsClass} btn-minus" type="button">${decrementButton}</button></div><input type="text" inputmode="decimal" style="text-align: ${textAlign}" class="form-control form-control-text-input"/><div class="input-group-append"><button style="min-width: ${buttonsWidth}" class="btn btn-increment ${buttonsClass} btn-plus" type="button">${incrementButton}</button></div></div>'};for(e in t)C[e]=t[e];var $=C.template.replace(/\${groupClass}/g,C.groupClass).replace(/\${buttonsWidth}/g,C.buttonsWidth).replace(/\${buttonsClass}/g,C.buttonsClass).replace(/\${decrementButton}/g,C.decrementButton).replace(/\${incrementButton}/g,C.incrementButton).replace(/\${textAlign}/g,C.textAlign);return this.each(function(){var r=N(this);r[0]["bootstrap-input-spinner"]=!0,r.hide(),r[0].inputSpinnerEditor=new C.editor(C,this);var e=null,n=null,o=N($),i=o.find(".btn-decrement"),a=o.find(".btn-increment"),p=o.find("input"),u=N("label[for='"+r.attr("id")+"']");u[0]||(u=r.closest("label"));var s=null,l=null,d=null;E();var c=parseFloat(r[0].value),t=r.attr("data-prefix")||"",f=r.attr("data-suffix")||"";t&&(t=N('<span class="input-group-text">'+t+"</span>"),o.find(".input-group-prepend").append(t)),f&&(m=N('<span class="input-group-text">'+f+"</span>"),o.find(".input-group-append").prepend(m)),r[0].setValue=function(t){b(t)},r[0].destroyInputSpinner=function(){r.prop("required",p.prop("required")),v.disconnect(),w(),p.off("paste input change focusout"),o.remove(),r.show(),u[0]&&u.attr("for",r.attr("id"))};var m,g,v=new MutationObserver(function(){E(),b(c,!0)});function b(t,e){void 0===e&&(e=!0),c=isNaN(t)||""===t?(r[0].value="",e&&(p[0].value=""),NaN):(t=parseFloat(t),t=Math.min(Math.max(t,s),l),r[0].value=t,e&&(p[0].value=r[0].inputSpinnerEditor.render(t)),t)}function h(e,n){n&&setTimeout(function(){var t;"function"==typeof Event?t=new Event(n,{bubbles:!0}):(t=document.createEvent("Event")).initEvent(n,!0,!0),e[0].dispatchEvent(t)})}function y(t){x(t),w(),e=setTimeout(function(){n=setInterval(function(){x(t)},C.autoInterval)},C.autoDelay)}function x(t){isNaN(c)&&(c=0),b(Math.round(c/t)*t+t),h(r,"input"),h(r,"change")}function w(){clearTimeout(e),clearTimeout(n)}function E(){r.prop("required")&&(p.prop("required",r.prop("required")),r.removeAttr("required")),p.prop("placeholder",r.prop("placeholder")),p.attr("inputmode",r.attr("inputmode")||"decimal");var t=r.prop("disabled"),e=r.prop("readonly");p.prop("disabled",t),p.prop("readonly",e||C.buttonsOnly),a.prop("disabled",t||e),i.prop("disabled",t||e),(t||e)&&w();t=r.prop("class"),e="";/form-control-sm/g.test(t)?e="input-group-sm":/form-control-lg/g.test(t)&&(e="input-group-lg");t=t.replace(/form-control(-(sm|lg))?/g,"");o.prop("class","input-group "+e+" "+C.groupClass),p.prop("class","form-control "+t),s=isNaN(r.prop("min"))||""===r.prop("min")?-1/0:parseFloat(r.prop("min")),l=isNaN(r.prop("max"))||""===r.prop("max")?1/0:parseFloat(r.prop("max")),d=parseFloat(r.prop("step"))||1,r.attr("hidden")?o.attr("hidden",r.attr("hidden")):o.removeAttr("hidden"),r.attr("id")&&(p.attr("id",r.attr("id")+"_MP_cBdLN29i2"),u[0]&&u.attr("for",p.attr("id")))}v.observe(r[0],{attributes:!0}),r.after(o),b(c),p.on("paste input change focusout",function(t){var e=p[0].value,n="focusout"===t.type;b(e=r[0].inputSpinnerEditor.parse(e),n),h(r,t.type)}).on("keydown",function(t){C.keyboardStepping&&(38===t.which?(t.preventDefault(),i.prop("disabled")||y(d)):40===t.which&&(t.preventDefault(),a.prop("disabled")||y(-d)))}).on("keyup",function(t){!C.keyboardStepping||38!==t.which&&40!==t.which||(t.preventDefault(),w())}),F(i[0],function(){i.prop("disabled")||y(-d)}),F(a[0],function(){a.prop("disabled")||y(d)}),m=document.body,g=function(){w()},m.addEventListener("mouseup",function(t){g(t)}),m.addEventListener("touchend",function(t){g(t)}),m.addEventListener("keyup",function(t){32!==t.keyCode&&13!==t.keyCode||(k=!1,g(t))})}),this}}(jQuery);

if ((typeof Theme) === 'undefined') { Theme = {}; }

Theme.redirectToCheckout = function() {
  window.location.href = "/checkout";
};

Theme.toggleAffix = function(affixElement, scrollElement, wrapper) {
  var height = affixElement.outerHeight(),
      top = wrapper.offset().top;

  if (scrollElement.scrollTop() >= top){
    wrapper.height(height);
    affixElement.addClass("affix");
  } else {
    affixElement.removeClass("affix");
    wrapper.height('auto');
  }
};

var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new bootstrap.Tooltip(tooltipTriggerEl)
});

if( jQuery(".timeline ul").length > 0 ) {
  var beginEnd = function(){
    jQuery('.timeline ul').each(function(){
      var begin = jQuery(this).find('li').offset().top - jQuery(window).height() + (jQuery(window).height() / 3);
      var end = begin + jQuery(this).outerHeight();
      if (jQuery(window).scrollTop() >= begin && jQuery(window).scrollTop() <= end){
        jQuery(this).find('.timeline-line').height(jQuery(window).scrollTop() - begin);
      }
    });
  }
  beginEnd();
  jQuery(window).scroll(function(){
    beginEnd();
  });
};

var contentGridEles = [].slice.call(document.querySelectorAll('section.content-grid'));
var contentGrids = contentGridEles.map(function (contentGridEle) {
  var blockTitleEle = contentGridEle.querySelector('.content .title-container');
  if(blockTitleEle &&  window.innerWidth < 992) {
    var contentHeader = document.createElement("div");
    var headerClasses = contentGridEle.getAttribute('data-header-class').split(',');
    headerClasses.forEach((element) => { if( element ) { contentHeader.classList.add( String(element) ); }; });
    contentHeader.innerHTML = blockTitleEle.innerHTML;
    blockTitleEle.remove();
    contentGridEle.querySelector('.container').prepend( contentHeader );
  };
});

var playVideo = function (e) {
  const { target } = e;
  const video = target.querySelector('video');
  if (video) video.play();
};

var pauseVideo = function (e) {
  const { target } = e;
  const video = target.querySelector('video');
  if (video) video.pause();
};


var handleNav = function (e) {
  if (e.target.id !== 'nav-menu') return;
  if (e.type === 'hidden.bs.collapse') document.documentElement.classList.remove('nav-active');
  else document.documentElement.classList.add('nav-active');
};

var closeNav = function (e) {
  const isInMenu = e.target.closest('#nav-menu');
  const isTrigger = e.target.closest('[data-bs-target="#nav-menu"]');
  if (isInMenu || !bootstrap || isTrigger) return;
  if (!document.documentElement.classList.contains('nav-active')) return;
  var navMenu = document.getElementById('nav-menu');
  new bootstrap.Collapse(navMenu, {
    hide: true
  });
};

/*
 On screens > 992px:
  - open + close nav on hover
*/

var enableNav = function (enable = false, { target }) {
  const button = target.querySelector('.accordion-button');
  const isClosed = !!button.classList.contains('collapsed');
  if (enable === isClosed) button.click();
};

var waitForHover;
var handleDesktop = function (e) {
  clearTimeout(waitForHover);
  const isDesktop = window.innerWidth >= 992;
  if (!isDesktop) return;
  const enable = e.type === 'mouseenter' && isDesktop;
  if (enable) return enableNav(enable, e);
  waitForHover = setTimeout(() => {
    enableNav(enable, e);
  }, 200);
};

var addEvents = function () {
  document.addEventListener('shown.bs.collapse', handleNav);
  document.addEventListener('hidden.bs.collapse', handleNav);
  document.addEventListener('show.bs.modal', playVideo);
  document.addEventListener('hide.bs.modal', pauseVideo);
  document.addEventListener('click', closeNav);

  const navAccordions = document.querySelectorAll('.main-nav .accordion-button');
  Array.from(navAccordions).map((el) => {
    const navLink = el.closest('.nav-link');
    navLink.addEventListener('mouseenter', handleDesktop);
    navLink.addEventListener('mouseleave', handleDesktop);
  });
}

addEvents();

/* END NAVIGATION */